var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChecking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28296_23420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28296_23420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H30V30H10V10Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28296_23420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 19.7854V23.1187C14.1667 23.8104 14.725 24.3687 15.4167 24.3687C16.1083 24.3687 16.6667 23.8104 16.6667 23.1187V19.7854C16.6667 19.0937 16.1083 18.5354 15.4167 18.5354C14.725 18.5354 14.1667 19.0937 14.1667 19.7854ZM19.1667 19.7854V23.1187C19.1667 23.8104 19.725 24.3687 20.4167 24.3687C21.1083 24.3687 21.6667 23.8104 21.6667 23.1187V19.7854C21.6667 19.0937 21.1083 18.5354 20.4167 18.5354C19.725 18.5354 19.1667 19.0937 19.1667 19.7854ZM13.75 28.5354H27.0833C27.775 28.5354 28.3333 27.9771 28.3333 27.2854C28.3333 26.5937 27.775 26.0354 27.0833 26.0354H13.75C13.0583 26.0354 12.5 26.5937 12.5 27.2854C12.5 27.9771 13.0583 28.5354 13.75 28.5354ZM24.1667 19.7854V23.1187C24.1667 23.8104 24.725 24.3687 25.4167 24.3687C26.1083 24.3687 26.6667 23.8104 26.6667 23.1187V19.7854C26.6667 19.0937 26.1083 18.5354 25.4167 18.5354C24.725 18.5354 24.1667 19.0937 24.1667 19.7854ZM19.6417 11.4438L13.0583 14.9104C12.7167 15.0854 12.5 15.4437 12.5 15.8271C12.5 16.4021 12.9667 16.8687 13.5417 16.8687H27.3C27.8667 16.8687 28.3333 16.4021 28.3333 15.8271C28.3333 15.4437 28.1167 15.0854 27.775 14.9104L21.1917 11.4438C20.7083 11.1854 20.125 11.1854 19.6417 11.4438Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28296_23420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChecking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checking.27861576dfe613cee1d514dc1d9506ce.svg";